import {combineReducers} from 'redux';

import userInfoReducer from './onboarding';
import preRegisterReducer from './preRegister';

const reducerList = {
    userInfo: userInfoReducer,
    preRegister: preRegisterReducer
}

export default reducerList;

const rootReducer = combineReducers(reducerList);

export type AppState = ReturnType<typeof rootReducer>;